export const getAdminProducts = () => {
  try {
    const saved = localStorage.getItem("vrm_admin_products");
    if (saved) {
      const parsed = JSON.parse(saved);
      // Clean up stale cached customers count from previous demo data
      const cleaned = parsed.map(p => ({
        ...p,
        customersCount: p.customers ? p.customers.length : 0,
        customers: p.customers || []
      }));
      return cleaned;
    }
  } catch (e) {
    console.error("Error loading products from localStorage", e);
  }
  return initialProductsList;
};


export const saveAdminProducts = (products) => {
  try {
    localStorage.setItem("vrm_admin_products", JSON.stringify(products));
    window.dispatchEvent(new Event("vrm_products_updated"));
  } catch (e) {
    console.error("Error saving products to localStorage", e);
  }
};

export const initialProductsList = [
  {
    id: 1,
    slug: "workflow-ai",
    name: "Workflow AI",
    description: "AI-powered recruitment & assessment suite (VideoSage, ScreenSage, CodeSage)",
    type: "SaaS / AI Suite",
    status: "Active",
    customersCount: 0,
    activeSubscriptionsCount: 0,
    avatarColor: "purple",
    createdAt: "10 Feb 2026",
    updatedAt: "06 Oct 2026",
    plans: [
      {
        id: 101,
        name: "Starter",
        description: "Basic recruitment pipeline with essential screening",
        price: 12000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 5,
        status: "Active",
        customersCount: 0
      },
      {
        id: 102,
        name: "Growth",
        description: "Automated candidate ranking, VideoSage & CodeSage access",
        price: 30000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 25,
        status: "Active",
        customersCount: 0
      },
      {
        id: 103,
        name: "Enterprise Scale",
        description: "Unlimited candidate screening & custom API integrations",
        price: 60000,
        currency: "INR",
        billingCycle: "Annual",
        seatLimit: 100,
        status: "Active",
        customersCount: 0
      }
    ],
    features: [
      { id: 201, name: "VideoSage Module", description: "AI video interviews & automatic speech transcription", status: "Active" },
      { id: 202, name: "ScreenSage Module", description: "AI resume parser & candidate ranking engine", status: "Active" },
      { id: 203, name: "CodeSage Module", description: "Automated multi-language coding test evaluator with anti-cheat", status: "Active" }
    ],
    customers: []
  },
  {
    id: 2,
    slug: "people-connect-ai",
    name: "People Connect AI",
    description: "AI-driven HR management, employee onboarding & workplace engagement platform",
    type: "HR Tech / SaaS",
    status: "Active",
    customersCount: 0,
    activeSubscriptionsCount: 0,
    avatarColor: "blue",
    createdAt: "15 Feb 2026",
    updatedAt: "05 Oct 2026",
    plans: [
      {
        id: 104,
        name: "Standard Plan",
        description: "Core HR onboarding, employee directory & attendance (Setup ₹5,000)",
        price: 15000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 25,
        status: "Active",
        customersCount: 0
      },
      {
        id: 105,
        name: "Enterprise Plan",
        description: "Multi-location HR suite, custom workflows & unlimited users",
        price: 50000,
        currency: "INR",
        billingCycle: "Annual",
        seatLimit: 200,
        status: "Active",
        customersCount: 0
      }
    ],
    features: [
      { id: 204, name: "Automated Onboarding", description: "Paperless document upload & digital signature collection", status: "Active" },
      { id: 205, name: "AI HR Helpdesk", description: "Automated employee query resolution bot", status: "Active" },
      { id: 206, name: "Attendance & Leaves", description: "Leave request approvals & leave balance tracker", status: "Active" }
    ],
    customers: []
  },
  {
    id: 3,
    slug: "ai-buddy",
    name: "AI Buddy",
    description: "AI-powered English communication & workplace speaking coach",
    type: "EdTech / SaaS",
    status: "Active",
    customersCount: 0,
    activeSubscriptionsCount: 0,
    avatarColor: "green",
    createdAt: "01 Mar 2026",
    updatedAt: "04 Oct 2026",
    plans: [
      {
        id: 106,
        name: "Basic Plan",
        description: "1-on-1 AI speaking practice & grammar feedback",
        price: 5000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 1,
        status: "Active",
        customersCount: 0
      },
      {
        id: 107,
        name: "Premium Plan",
        description: "Team dashboard, accent training & corporate progress benchmarks",
        price: 20000,
        currency: "INR",
        billingCycle: "Annual",
        seatLimit: 30,
        status: "Active",
        customersCount: 0
      }
    ],
    features: [
      { id: 207, name: "Speech Coach AI", description: "Real-time pronunciation, grammar & accent feedback", status: "Active" },
      { id: 208, name: "Scenario Drills", description: "Workplace meeting & presentation roleplay scenarios", status: "Active" }
    ],
    customers: []
  },
  {
    id: 4,
    slug: "vrm-ai-estate",
    name: "VRM AI Estate",
    description: "AI-driven real estate lead management & automated site visit call assistant",
    type: "PropTech / SaaS",
    status: "Active",
    customersCount: 0,
    activeSubscriptionsCount: 0,
    avatarColor: "amber",
    createdAt: "12 Mar 2026",
    updatedAt: "03 Oct 2026",
    plans: [
      {
        id: 108,
        name: "Starter Site Visits",
        description: "Includes 100 automated site visit voice AI calls / mo",
        price: 10000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 5,
        status: "Active",
        customersCount: 0
      },
      {
        id: 109,
        name: "Pro Site Visits",
        description: "Includes 500 site visit calls & priority lead scoring",
        price: 35000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 20,
        status: "Active",
        customersCount: 0
      },
      {
        id: 110,
        name: "Enterprise Estate",
        description: "Unlimited site visit calls, multi-brokerage CRM & custom workflows",
        price: 80000,
        currency: "INR",
        billingCycle: "Annual",
        seatLimit: 100,
        status: "Active",
        customersCount: 0
      }
    ],
    features: [
      { id: 209, name: "Voice AI Call Dispatcher", description: "Automated site visit booking and confirmation calls", status: "Active" },
      { id: 210, name: "Lead Intent Scoring", description: "AI buyer rating based on engagement & inquiry patterns", status: "Active" }
    ],
    customers: []
  },
  {
    id: 5,
    slug: "exit-intelligence",
    name: "Exit Intelligence",
    description: "AI-powered exit interview automation & employee attrition analytics",
    type: "HR Tech / Analytics",
    status: "Active",
    customersCount: 0,
    activeSubscriptionsCount: 0,
    avatarColor: "indigo",
    createdAt: "20 Mar 2026",
    updatedAt: "02 Oct 2026",
    plans: [
      {
        id: 111,
        name: "Standard Exit",
        description: "Includes 100 automated voice exit interview calls / mo",
        price: 15000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 10,
        status: "Active",
        customersCount: 0
      },
      {
        id: 112,
        name: "Enterprise Exit",
        description: "Unlimited exit interviews, predictive attrition models & custom reports",
        price: 45000,
        currency: "INR",
        billingCycle: "Annual",
        seatLimit: 50,
        status: "Active",
        customersCount: 0
      }
    ],
    features: [
      { id: 211, name: "Voice AI Exit Calls", description: "Conversational voice AI agent conducts unbiased exit interviews", status: "Active" },
      { id: 212, name: "Attrition Analytics", description: "Sentiment scoring and root-cause turnover report generator", status: "Active" }
    ],
    customers: []
  },
  {
    id: 6,
    slug: "visionix-ai",
    name: "Visionix AI",
    description: "Facial recognition AI attendance, CCTV computer vision & security analytics",
    type: "Vision AI / Security",
    status: "Active",
    customersCount: 0,
    activeSubscriptionsCount: 0,
    avatarColor: "red",
    createdAt: "15 Jan 2026",
    updatedAt: "01 Oct 2026",
    plans: [
      {
        id: 113,
        name: "Standard Plan",
        description: "Touchless facial attendance for up to 50 employees (Setup ₹5,000)",
        price: 25000,
        currency: "INR",
        billingCycle: "Monthly",
        seatLimit: 50,
        status: "Active",
        customersCount: 0
      },
      {
        id: 114,
        name: "Enterprise Plan",
        description: "Multi-location biometric vision AI & custom security alerts",
        price: 75000,
        currency: "INR",
        billingCycle: "Annual",
        seatLimit: 500,
        status: "Active",
        customersCount: 0
      }
    ],
    features: [
      { id: 213, name: "Facial Recognition Attendance", description: "Sub-second touchless face verification with anti-spoofing", status: "Active" },
      { id: 214, name: "Multi-Camera Sync", description: "Connects to existing IP CCTV streams for real-time security alerts", status: "Active" }
    ],
    customers: []
  }
];

